export default "__VITE_ASSET__df039529__"